import { apiClient } from 'api'
import { League } from 'types/leagues'

type NewItem = Omit<League, 'id'>

export const getLeagues = () => apiClient.get<League[]>('/leagues')

export const getLeagueById = (fieldId: number) => apiClient.get<League>(`/leagues/${fieldId}`)

export const createLeague = (field: NewItem) => apiClient.post<NewItem, League>('/leagues', field)

export const editLeague = (league: League) => apiClient.patch<League>(`/leagues/${league.id}`, league)

export const deleteLeague = (id: number) => apiClient.delete(`/leagues/${id}`)
